import { Injectable } from '@angular/core';
import { CentralService } from '../central.service';

@Injectable({
  providedIn: 'root'
})

export class CitiesService extends CentralService {

  protected resource: string = "cities";

}
